// src/lib/calendar-active-resas.js
// Source UNIQUE de la notion de « réservation active » au calendrier.
//
// Pourquoi ce module : le compteur du pied de page (CalendarPanel) affichait
// `filtered.length`, qui inclut les réservations annulées, alors que la vue
// Tableau (TableauView) et la vue Aujourd'hui (_today-helpers) les retirent
// avant de dessiner. Résultat : « 12 résas sur la fenêtre juillet » sous un
// tableau qui n'en dessinait que 8. Le filtre vit désormais ici, et les deux
// côtés (ce qui est compté / ce qui est dessiné) en dérivent.
//
// Helper PUR : aucun accès réseau, aucun DOM, aucune écriture.
//
// NB orthographe : la base porte historiquement les deux graphies du statut
// annulé ('cancelled' britannique, 'canceled' américain). Les deux sont
// traitées, comme le faisait le filtre inline de TableauView.

const CANCELLED_STATUSES = ['cancelled', 'canceled']

/**
 * Une réservation est ACTIVE si elle n'est pas annulée.
 *
 * @param {{ status?: string }} resa
 * @returns {boolean}
 */
export function isResaActive(resa) {
  return !CANCELLED_STATUSES.includes(resa?.status)
}

/**
 * Retire les réservations annulées d'une liste.
 *
 * @param {Array<{ status?: string }>} resas — liste (nullish toléré).
 * @returns {Array<object>} nouvelle liste, ordre préservé.
 */
export function filterActiveResas(resas) {
  return (resas || []).filter((r) => r && isResaActive(r))
}

/**
 * Nombre de réservations effectivement dessinées au calendrier.
 *
 * `knownLogementIds` (optionnel, Set) : la vue Tableau SKIPPE une résa dont le
 * logement est absent de cfg (`logementRow.get(...) == null`) — le compteur
 * doit l'exclure aussi, sinon « N résas » sous un tableau qui en dessine N−1.
 *
 * @param {Array<{ status?: string }>} resas — liste (nullish toléré).
 * @param {Set<string>} [knownLogementIds] — ids de logements connus de cfg.
 * @returns {number}
 */
export function countActiveResas(resas, knownLogementIds) {
  const actives = filterActiveResas(resas)
  if (!knownLogementIds) return actives.length
  return actives.filter((r) => knownLogementIds.has(r.logement_id)).length
}
